import { Paper, Typography } from '@mui/material'
import parser from 'html-react-parser'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { ModalWrapper } from 'src/components/modal-wrapper'
import { IEmailLogDto } from 'src/types'

import { useStyles } from './styles'
import { EmailIcon } from 'src/assets/icons/v2/EmailIcon'

interface IEmailLogFormModalProps {
  open: boolean
  handleClose: () => void
  formValues: IEmailLogDto | null
}

const EmailLogFormModal = ({ open, handleClose, formValues }: IEmailLogFormModalProps) => {
  const classes = useStyles()

  if (!formValues) {
    return null
  }

  return (
    <ModalWrapper open={open} className={classes.modalWrapper} onClose={handleClose}>
      <div className={classes.tableHeader}>
        <EmailIcon size={80} />
        <Typography className={classes.title}>
          <HelperWrapper t="email-logs-header-title" />
        </Typography>
      </div>
      <div>
        <Typography className={classes.label}>
          <HelperWrapper t="email-logs-subject-title" />
        </Typography>
        <Typography className={classes.value}>{formValues.subject}</Typography>
      </div>
      <div>
        <Typography className={classes.label}>
          <HelperWrapper t="email-logs-content-title" />
        </Typography>
        <Paper className={classes.parsedWrapper}>{parser(formValues.body)}</Paper>
      </div>
    </ModalWrapper>
  )
}

export { EmailLogFormModal }
